import { motion } from "framer-motion";
import { useI18n } from "@/i18n";
import { TimelineStep } from "./TimelineStep";
import type { StepContent } from "@/i18n/types";

export function Timeline() {
  const { t } = useI18n();

  const steps: { key: string; content: StepContent; isPhotoStep?: boolean }[] = [
    { key: "booking", content: t.steps.booking },
    { key: "dressing", content: t.steps.dressing },
    { key: "makeup", content: t.steps.makeup },
    { key: "photography", content: t.steps.photography },
    { key: "returnKimono", content: t.steps.returnKimono },
    { key: "receivePhotos", content: t.steps.receivePhotos, isPhotoStep: true },
  ];

  return (
    <section className="px-5 sm:px-8 max-w-2xl mx-auto">
      {/* Section divider */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="flex items-center gap-4 mb-10"
      >
        <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-surface-3" />
        <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-ink-3">
          The Journey
        </span>
        <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-surface-3" />
      </motion.div>

      {/* Steps */}
      <div>
        {steps.map((step, i) => (
          <TimelineStep
            key={step.key}
            step={step.content}
            index={i}
            total={steps.length}
            isPhotoStep={step.isPhotoStep}
          />
        ))}
      </div>
    </section>
  );
}
